<template>
    <div class="account">
        <div class="top_header_fixed" v-if="postList.headerTitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'performanceAssignmentList' }">绩效分配</el-breadcrumb-item>
                <el-breadcrumb-item>批量分配</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="height: 30px" v-if="postList.headerTitle"></div>
        <div class="main_list">
            <el-button
                size="small"
                plain
                @click="insert"
                icon="el-icon-plus"
                v-if="postList.params.type != 'detail'"
                style="margin-left:10px; "
                >新增行</el-button
            >
            <el-button size="small" plain @click="submit()" :loading="btnLoading" v-if="postList.headerTitle">保存</el-button>
            <div class="flex">
                <div class="main_header_btns">
                    <draggableList
                        :draggable="draggable"
                        @isErrShow="onSetFieldDone"
                        v-if="postList.params.type == 'detail'"
                    ></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="performance_assignment_line"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="
                            postList.params.type == 'detail'
                                ? item.width
                                : in_array(item.prop, fieldType)
                                ? fieldTypeMap[item.prop].col_width
                                : item.width
                        "
                        :sortable="item.sort"
                        align="left"
                        v-if="
                            (postList.params.type == 'detail' && colData[index].is_show) ||
                            (postList.params.type != 'detail' && in_array(item.prop, fieldType))
                        "
                    >
                        <template slot-scope="scope">
                            <div v-if="postList.params.type == 'detail'">
                                <div v-if="in_array(item.prop, ['xxx'])">
                                    <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                        >{{ scope.row[item.prop] }}
                                    </el-link>
                                </div>
                                <div v-else>
                                    <span> {{ scope.row[item.prop] }} </span>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="fieldTypeMap[item.prop].type == 'input'">
                                    <el-input
                                        clearable
                                        :placeholder="fieldTypeMap[item.prop].title"
                                        :style="fieldTypeMap[item.prop].style"
                                        v-model="scope.row[item.prop]"
                                    ></el-input>
                                </div>
                                <div v-else-if="fieldTypeMap[item.prop].type == 'dropdown'">
                                    <el-select
                                        clearable
                                        filterable
                                        :style="fieldTypeMap[item.prop].style"
                                        v-model="scope.row[item.prop]"
                                        :placeholder="fieldTypeMap[item.prop].title"
                                    >
                                        <el-option
                                            v-for="option in options[item.prop]"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <el-table-column v-if="postList.params.type != 'detail'" label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="新增行" placement="top-start">
                            <i class="el-icon-circle-plus-outline" @click="add(scope.row, scope.$index)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除行" placement="top-start" style="margin-left: 5px">
                            <i class="el-icon-remove-outline" @click="remove(scope.row, scope.$index)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="复制行" placement="top-start" style="margin-left: 5px">
                            <i class="el-icon-document-copy" @click="copy(scope.row, scope.$index)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-show="false">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import vSearchSelect from '@/components/common/dropdown/search.vue';
import { onReSize, onSearch, in_array } from '@/js/common';
import draggableList from '@/components/common/Drawer.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'performanceAssignmentLineListComponent',
    data() {
        return {
            draggable: {
                data_name: 'performance_assignment_line'
            },
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            queryParams: {},
            fieldTypeMap: {},
            fieldType: [],
            sequence: 0,
            options: {},
            btnLoading: false
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.selectedColData(); //筛选列
        this.initFieldTypeMap();
        this.initQueryParams();
        this.initOptions();
        this.getList(0);
    },
    mounted() {
        this.$nextTick(() => {});
    },
    methods: {
        in_array,
        incrementSequence() {
            this.sequence++;
        },
        initFieldTypeMap() {
            this.fieldType = ['performance_unit_code', 'percent'];
            this.fieldTypeMap = {
                performance_unit_code: {
                    type: 'dropdown',
                    title: '绩效单元(必填)',
                    // col_width: 300,
                    style: 'width: 90%;'
                },
                percent: {
                    type: 'input',
                    title: '百分比(必填)',
                    // col_width: 1000,
                    style: 'width: 90%;'
                }
            };
        },
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 100,
                is_export: 0,
                performance_assignment_rid: this.postList.params.performance_assignment_rid // 子页面，必定有params，不判断
            };
        },
        async initOptions() {
            await Promise.all([
                this.$api['dropdownPerformanceUnit']({})
                    .then((res) => {
                        this.options['performance_unit_code'] = [];
                        res.data.forEach((item) => {
                            this.options['performance_unit_code'].push({
                                value: item['code'],
                                label: item['name']
                            });
                        });
                    })
                    .catch((error) => {})
            ]);

            if (this.postList.params.type == 'insert') {
                this.insert();
                this.insert();
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            if (this.postList.params.type == 'detail') {
                onReSize('performance_assignment_line', this);
            } else {
                // 不要设置了，会跟详情冲突，除非显示字段数量一致
                // onReSize('performance_assignment_line', this, 0, this.fieldType);
            }
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).performance_assignment_line;
        },
        saveQueryParams() {},
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            if (this.postList.params.type == 'insert') {
                this.loading = false;
                this.tableData = [];
            } else {
                onSearch(search_type, this, 'performanceAssignmentLineLists');
            }
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.getList(0);
        },
        // 保存
        save(row) {},
        insert() {
            let row = {};
            let index = 0;
            this.fieldType.forEach((key) => {
                row[key] = null;
            });
            row['id'] = 1;
            this.add(row, index);
        },
        add(row, index) {
            let new_row = JSON.parse(JSON.stringify(row));
            new_row.id = String(new_row.id);
            this.sequence++;
            let temp = new_row.id.split('_');
            Object.keys(new_row).forEach((key) => {
                new_row[key] = null;
            });
            new_row.id = temp[0] + '_' + this.sequence;
            this.tableData.splice(index + 1, 0, new_row);
        },
        copy(row, index) {
            let new_row = JSON.parse(JSON.stringify(row));
            new_row.id = String(new_row.id);
            this.sequence++;
            let temp = new_row.id.split('_');
            new_row.id = temp[0] + '_' + this.sequence;
            this.tableData.splice(index + 1, 0, new_row);
        },
        remove(row, index) {
            // if (this.tableData.length <= 1) {
            //     this.$message.error('请至少保留一行');
            //     return false;
            // }
            this.tableData.splice(index, 1);
        },
        //提交新增/编辑修改
        submit() {
            let formData = {};
            formData.performance_assignment_rid = this.postList.params.performance_assignment_rid;
            formData.data = [];

            this.tableData.forEach((item) => {
                if (!(!item.performance_unit_code && (item.percent === null || item.percent === ''))) {
                    formData.data.push(item);
                }
            });

            this.btnLoading = true;
            this.$api['performanceAssignmentLineSave'](formData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });

                        if (this.postList.headerTitle) {
                            if (window.history.length <= 1) {
                                this.$router.push({
                                    path: 'performanceAssignmentList'
                                });
                            } else {
                                this.$router.go(-1);
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
</style>